/*
  Bridges Shopify's cookie banner to Google Consent Mode.

  theme.liquid defaults every consent signal to denied before GTM loads, so
  nothing is written until we know the visitor's answer. This file reads that
  answer from Shopify's Customer Privacy API and releases or holds the tags.

  It does not render or alter the banner - Shopify owns that, including the
  wording. We only mirror the decision the visitor makes in it.
*/
(function () {
  function gtagConsent(granted) {
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    var v = granted ? 'granted' : 'denied';
    gtag('consent', 'update', {
      ad_storage: v,
      ad_user_data: v,
      ad_personalization: v,
      analytics_storage: v
    });
  }

  function sync() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return;

    /* Where Shopify still needs to ask, leave everything denied and wait for
       the visitor. Where it does not - outside a regulated region, or already
       answered - honour the consent on record so analytics is not left dead. */
    var mustAsk = false;
    try { mustAsk = cp.shouldShowBanner(); } catch (e) {}
    if (mustAsk) return;

    var allowed = true;
    try { allowed = cp.analyticsProcessingAllowed(); } catch (e) {}
    gtagConsent(allowed);
  }

  /* Fired by Shopify when the visitor answers the banner or changes their
     preferences later. */
  document.addEventListener('visitorConsentCollected', function (event) {
    var d = (event && event.detail) || {};
    gtagConsent(d.analyticsAllowed === true || d.marketingAllowed === true);
  });

  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (err) { if (!err) sync(); }
    );
  }
})();
